/* Holster catalog (Dave, 19 Oct 2026). One card per style; with a gun remembered, each card says whether it fits.
   Fit comes only from the GunMatch gun rows (the master sheet's published copy) and the store's own handles:
   a size with no product behind it is not a fit. Nothing here guesses a size. */
(function () {
  var root = document.getElementById('ucc-cat'); if (!root) return;
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(n, p) { try { if (window.gtag) window.gtag('event', n, p || {}); } catch (e) { console.log('uc-catalog gtag', e); } }
  var D = {}; try { D = JSON.parse($('ucc-data').textContent); } catch (e) { console.log('uc-catalog data', e); }
  var grid = $('ucc-grid'), cards = [].slice.call(grid.querySelectorAll('.ucc-card'));
  cards.forEach(function (c, i) { c.dataset.i = i; });

  /* ---------- filters ---------- */
  // Three rows of buttons in one strip: carry style (one at a time), line (one at a time) and features, which stay on
  // together (Dave, 20 Oct 2026: "some customers have both" an optic and a light; Hyperion takes both). Mavado is a
  // LockLeather holster; Hyperion is not.
  var CHIPS = [['owb', 'OWB', 'style'], ['iwb', 'IWB', 'style'], ['g3', 'Below the belt', 'style'], ['shoulder', 'Shoulder', 'style'],
    ['lockleather', 'LockLeather', 'line'], ['mavado', 'Mavado', 'line'], ['hyperion', 'Hyperion', 'line'],
    ['optic', 'Optic cut', 'feat'], ['light', 'Light / laser', 'feat'], ['mag', 'Mag pouches', 'style'], ['cancan', 'CanCan', 'style']];
  var S = { style: '', line: '', feat: {}, gun: null, sub: '' };
  var q = /[?&]style=([a-z0-9]+)/.exec(location.search);
  function has(c, t) { return (' ' + (c.dataset.tags || '') + ' ').indexOf(' ' + t + ' ') > -1; }
  var present = [];
  // Gear page arrangement from the section settings (Dave, 20 Oct 2026): the gift card first, groups renamed
  // ("Weapon Cleaning" is Leather Care, "Accessories" is Range Gear), single items moved into an Other group, the
  // buttons in a set order, and the knives kept together and ordered by kind
  var C = D.cfg || {};
  function pairs(s) { var o = {}; String(s || '').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) o[kv.slice(0, i).trim()] = kv.slice(i + 1).trim(); }); return o; }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  var TN = pairs(C.names), HT = pairs(C.htypes), ORDER = list(C.order), KNIFE = C.knife || 'Knives';
  var SUBS = String(C.subs || '').split(';').map(function (kv) { var p = kv.split('='); return [p[0].trim().toLowerCase(), (p[1] || p[0]).trim()]; }).filter(function (x) { return x[0]; });
  function subOf(c) { var t = (c.dataset.sub || '').toLowerCase(); for (var i = 0; i < SUBS.length; i++) if (t.indexOf(SUBS[i][0]) > -1) return i; return SUBS.length; }
  function arrange() {
    cards.forEach(function (c) { var t = HT[c.dataset.fam] || TN[c.dataset.type]; if (t) c.dataset.type = t; });
    var kn = cards.filter(function (c) { return c.dataset.type === KNIFE; });
    if (SUBS.length && kn.length) {
      var after = kn[kn.length - 1].nextSibling;
      kn.forEach(function (c) { c.dataset.ksub = 'ksub-' + subOf(c); });
      kn.sort(function (a, b) { return subOf(a) - subOf(b) || a.dataset.i - b.dataset.i; }).forEach(function (c) { grid.insertBefore(c, after); });
    }
    list(C.first).reverse().forEach(function (h) { cards.forEach(function (c) { if (c.dataset.fam === h) grid.insertBefore(c, grid.firstChild); }); });
    cards = [].slice.call(grid.querySelectorAll('.ucc-card')); cards.forEach(function (c, i) { c.dataset.i = i; });
  }
  if (C.names || C.htypes || C.first || SUBS.length) arrange();
  function rank(t) { var i = ORDER.indexOf(t); return i < 0 ? ORDER.length : i; }
  function findPresent() {
    present = CHIPS.filter(function (ch) { return cards.some(function (c) { return has(c, ch[0]); }); });
    if (present.length) { if (ORDER.length) sortPresent(); return; }
    // Belts, accessories, gear: one button per product type when there are two or more
    var types = []; cards.forEach(function (c) { var t = c.dataset.type; if (t && types.indexOf(t) < 0) types.push(t); });
    if (types.length < 2) return;
    types.forEach(function (t) {
      var id = 'type-' + t.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      cards.forEach(function (c) { if (c.dataset.type === t) c.dataset.tags = (c.dataset.tags || '') + ' ' + id; });
      present.push([id, t, 'style']); if (!CHIPS.some(function (x) { return x[0] === id; })) CHIPS.push([id, t, 'style']);
    });
    if (ORDER.length) sortPresent();
  }
  function sortPresent() { present = present.map(function (ch, i) { return [ch, i]; }).sort(function (a, b) { return rank(a[0][1]) - rank(b[0][1]) || a[1] - b[1]; }).map(function (x) { return x[0]; }); }
  var KID = 'type-' + KNIFE.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  function subChips() {
    // With Knives picked, a second row narrows it by kind; the knives with no kind are "Other"
    if (S.style !== KID || !SUBS.length) return '';
    var seen = {}; cards.forEach(function (c) { if (c.dataset.ksub) seen[c.dataset.ksub] = 1; });
    var subs = SUBS.map(function (x, i) { return ['ksub-' + i, x[1]]; }).concat([['ksub-' + SUBS.length, 'Other']]).filter(function (x) { return seen[x[0]]; });
    if (subs.length < 2) return '';
    return '<button type="button" data-chip="' + KID + '-all" aria-pressed="' + !S.sub + '">All knives</button>' + subs.map(function (x) { return '<button type="button" data-chip="' + x[0] + '" aria-pressed="' + (S.sub === x[0]) + '">' + esc(x[1]) + '</button>'; }).join('');
  }
  findPresent();
  if (q) present.forEach(function (ch) { if (ch[0] === q[1]) { if (ch[2] === 'feat') S.feat[ch[0]] = 1; else S[ch[2]] = ch[0]; } });
  function on(ch) { return ch[2] === 'feat' ? !!S.feat[ch[0]] : S[ch[2]] === ch[0]; }
  function any() { return !!(S.style || S.line || Object.keys(S.feat).length); }
  function renderChips() {
    $('ucc-chips').innerHTML = present.length > 1 ? '<button type="button" data-chip="all" aria-pressed="' + !any() + '">All</button>' + present.map(function (ch, i) {
      var sep = i && present[i - 1][2] !== ch[2] ? ' class="ucc-chip--gap"' : '';
      return '<button type="button"' + sep + ' data-chip="' + ch[0] + '" aria-pressed="' + on(ch) + '">' + esc(ch[1]) + '</button>';
    }).join('') : '';
    var sub = $('ucc-subchips');
    if (!sub && SUBS.length) { sub = document.createElement('div'); sub.id = 'ucc-subchips'; sub.className = 'ucc-cat__chips ucc-cat__chips--sub'; $('ucc-chips').parentNode.insertBefore(sub, $('ucc-chips').nextSibling); }
    if (sub) { sub.innerHTML = subChips(); sub.hidden = !sub.innerHTML; }
  }
  function applyChip() {
    var shown = 0, feats = Object.keys(S.feat);
    cards.forEach(function (c) {
      var ok = has(c, 'used') || ((!S.style || has(c, S.style)) && (!S.line || has(c, S.line)) && (!S.sub || c.dataset.ksub === S.sub) && feats.every(function (f) { return has(c, f); }));
      c.hidden = !ok; if (ok && !has(c, 'used')) shown++;
    });
    $('ucc-none').hidden = shown > 0;
  }
  function chipClick(id) {
    if (id === 'all') { S.style = ''; S.line = ''; S.feat = {}; S.sub = ''; }
    else if (id === KID + '-all') { S.sub = ''; }
    else if (id.indexOf('ksub-') === 0) { S.sub = S.sub === id ? '' : id; }
    else {
      S.sub = '';
      var ch = CHIPS.filter(function (x) { return x[0] === id; })[0]; if (!ch) return;
      // Mag pouches is a view of its own: it clears the other filters, and any other filter clears it (Dave, 20 Oct 2026)
      // CanCan works the same way: its items are not LockLeather, optic or light holsters
      if (id === 'mag' || id === 'cancan') { var was = S.style === id; S.style = was ? '' : id; S.line = ''; S.feat = {}; }
      else { if (S.style === 'mag' || S.style === 'cancan') S.style = '';
        if (ch[2] === 'feat') { if (S.feat[id]) delete S.feat[id]; else S.feat[id] = 1; }
        else S[ch[2]] = S[ch[2]] === id ? '' : id; }
    }
    renderChips(); applyChip();
    track('catalog_filter', { style: S.style, line: S.line, feat: Object.keys(S.feat).join(',') });
  }

  /* ---------- styles past the first 250 products (Liquid lists 250 at most) ---------- */
  function famKey(h) {
    if (/urban-carry-g3-/.test(h)) return /magnet/.test(h) ? 'g3-magnet' : 'g3-click';
    return h.replace(/-(\d{3})$/, function (m, n) { return +n > 100 ? '' : m; });
  }
  function moreStyles() {
    var count = +root.getAttribute('data-count') || 0; if (count <= 250) return Promise.resolve();
    var have = {}; cards.forEach(function (c) { if (c.dataset.fam) have[c.dataset.fam] = 1; });
    // Late styles go above the CanCan group and the Gently Used card, which stay at the bottom
    var used = cards.filter(function (c) { return has(c, 'cancan'); })[0] || cards.filter(function (c) { return has(c, 'used'); })[0];
    var pages = []; for (var pg = 2; pg <= Math.ceil(count / 250); pg++) pages.push(pg);
    return Promise.all(pages.map(function (pg) { return fetch('/collections/' + root.getAttribute('data-collection') + '/products.json?limit=250&page=' + pg).then(function (r) { return r.ok ? r.json() : { products: [] }; }); }))
      .then(function (js) {
        js.forEach(function (j) { (j.products || []).forEach(function (p) {
          var k = famKey(p.handle); if (have[k] || /gently-used/.test(p.handle) || /TEST/.test(p.title)) return; have[k] = 1;
          var name = String(p.title).split(/[―—]/)[0].trim(), tl = name.toLowerCase();
          var tags = /iwb/.test(tl) ? 'iwb' : /owb/.test(tl) ? 'owb' : /magazine/.test(tl) ? 'mag' : 'other';
          var img = p.images && p.images[0] ? p.images[0].src : '', price = Math.min.apply(null, (p.variants || []).map(function (v) { return +v.price; }));
          var li = document.createElement('li'); li.className = 'ucc-card'; li.dataset.fam = k; li.dataset.tags = tags; li.dataset.href = '/products/' + p.handle;
          li.innerHTML = '<a class="ucc-card__a" href="/products/' + esc(p.handle) + '"><span class="ucc-card__img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + esc(name) + '" loading="lazy" width="600" height="600">' : '') + '</span><span class="ucc-card__tx"><span class="ucc-card__nm">' + esc(name) + '</span><span class="ucc-card__pr">$' + price.toFixed(2) + '</span><span class="ucc-card__fit" hidden></span></span></a>';
          li.dataset.i = cards.length; grid.insertBefore(li, used || null); cards.push(li);
        }); });
      }).catch(function (e) { console.log('uc-catalog more', e); });
  }

  /* ---------- fit ---------- */
  // Gun row columns (gunmatch-guns.js): 0 id, 1 make, 2 model, 5 Sig OWB, 6 Sig IWB, 7 RMR OWB, 8 RMR IWB, 9 shoulder,
  // 10 Mavado, 11 G3, 12 G3 with an extended light, 13 Hyperion, 14 has a page, 15 style (R = revolver), 17 lines not made
  function handleFor(fam, r) {
    var blk = String(r[17] || ''), L = blk.indexOf('L') > -1, M = blk.indexOf('M') > -1, G = blk.indexOf('G') > -1, H = blk.indexOf('H') > -1;
    var s = function (i) { return String(r[i] || '').trim(); };
    var tier = function (t) { return t ? t.split('/')[0].trim().toLowerCase() : ''; };
    switch (fam) {
      case 'lockleather-owb-holster': return !L && s(5) && fam + '-' + s(5);
      case 'lockleather-iwb-holster': return !L && s(6) && fam + '-' + s(6);
      case 'lockleather-owb-extra-mag': return !L && s(5) && fam + '-' + s(5);
      case 'lockleather-owb-rmr-rds-holster': return !L && s(7) && fam + '-' + s(7);
      case 'lockleather-iwb-rmr-rds-holster': return !L && s(8) && fam + '-' + s(8);
      case 'lockleather-shoulder-holster': return !L && s(9) && fam + '-' + s(9);
      case 'lockleather-shoulder-holster-rmr': return !L && s(9) && (s(7) || s(8)) && fam + '-' + s(9);
      case 'mavado-owb': case 'mavado-iwb': return !M && s(10) && fam + '-' + s(10);
      case 'hyperion-owb': case 'hyperion-iwb': return !H && s(13) && fam + '-' + s(13);
      // Revolvers never take the Click clip (gunmatch.js)
      case 'g3-click': return !G && s(11) && r[15] !== 'R' && blk.indexOf('C') < 0 && 'urban-carry-g3-' + tier(s(11)) + '-click-retention';
      case 'g3-magnet': return !G && (s(11) || s(12)) && 'urban-carry-g3-' + tier(s(11) || s(12)) + '-magnet-retention';
    }
    return undefined; // not a gun-fitted product (mag pouches, accessories): no badge
  }
  // Gently Used catalog: the same fit, read against used stock (Dave, 20 Oct 2026)
  var USED = root.getAttribute('data-used') === 'true';
  var U2N = { 'gently-used-signature-owb': 'lockleather-owb-holster', 'gently-used-signature-iwb': 'lockleather-iwb-holster',
    'gently-used-signature-owb-rmr-rds-holster': 'lockleather-owb-rmr-rds-holster', 'gently-used-signature-iwb-rmr-rds-holster': 'lockleather-iwb-rmr-rds-holster',
    'gently-used-signature-owb-extra-mag': 'lockleather-owb-extra-mag', 'gently-used-mavado-owb': 'mavado-owb', 'gently-used-mavado-iwb': 'mavado-iwb',
    'gently-used-hyperion-owb': 'hyperion-owb', 'gently-used-hyperion-iwb': 'hyperion-iwb',
    'gently-used-signature-shoulder-holster': 'lockleather-shoulder-holster', 'gently-used-signature-shoulder-holster-rmr': 'lockleather-shoulder-holster-rmr' };
  function toUsed(h) {
    return h.replace(/^lockleather-(owb|iwb)-holster-/, 'gently-used-signature-$1-').replace(/^lockleather-(owb|iwb)-rmr-rds-holster-/, 'gently-used-signature-$1-rmr-rds-holster-')
      .replace(/^lockleather-owb-extra-mag-/, 'gently-used-signature-owb-extra-mag-').replace(/^lockleather-shoulder-holster-/, 'gently-used-signature-shoulder-holster-')
      .replace(/^(mavado|hyperion|urban-carry-g3)-/, 'gently-used-$1-');
  }
  function fitHandle(fam, r) {
    var h = handleFor(USED ? (U2N[fam] || fam) : fam, r);
    return h && USED ? toUsed(h) : h;
  }
  var HANDLES = null;
  function loadHandles() {
    if (HANDLES) return Promise.resolve(HANDLES);
    var base = D.all || '/collections/holsters/products.json?limit=250';
    return Promise.all([1, 2].map(function (pg) {
      return fetch(base + '&page=' + pg, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('products ' + r.status); return r.json(); });
    })).then(function (js) {
      HANDLES = {}; js.forEach(function (j) { (j.products || []).forEach(function (p) { HANDLES[p.handle] = p.variants && p.variants.some(function (v) { return v.available; }); }); });
      return HANDLES;
    });
  }
  var gunsLoading = null;
  function loadGuns() {
    if (window.GUNS) return Promise.resolve(window.GUNS);
    if (window.__gmbLoad) return window.__gmbLoad.then(function () { return window.GUNS || []; });
    if (gunsLoading) return gunsLoading;
    gunsLoading = new Promise(function (ok, fail) { var sc = document.createElement('script'); sc.src = D.guns; sc.onload = function () { ok(window.GUNS || []); }; sc.onerror = fail; document.head.appendChild(sc); });
    return gunsLoading;
  }
  function gunName(r) { return (String(r[1]).replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim() + ' ' + r[2]).trim(); }
  function gunShort(r) { var m = String(r[2]).replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim(); return (String(r[1]).replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim() + ' ' + (m || r[2])).trim(); }

  function clearFit() {
    cards.forEach(function (c) {
      c.classList.remove('is-fit', 'is-nofit');
      var a = c.querySelector('a'); if (c.dataset.href) a.href = c.dataset.href;
      var f = c.querySelector('.ucc-card__fit'); if (f) { f.hidden = true; f.textContent = ''; }
    });
    cards.slice().sort(function (a, b) { return a.dataset.i - b.dataset.i; }).forEach(function (c) { grid.appendChild(c); });
  }
  function renderGun() {
    var lbl = $('ucc-gunlbl'), inp = document.getElementById('ucc-q'); if (!lbl) return;
    if (!S.gun) { lbl.innerHTML = 'Type your gun and we will mark the holsters that fit it.'; if (inp) inp.placeholder = 'Your gun make and model'; }
    else {
      lbl.innerHTML = 'Showing fit for <b>' + esc(gunName(S.gun)) + '</b> <button type="button" class="ucc-cat__lnk" data-gun="clear">Clear</button>';
      if (inp) { inp.placeholder = 'Another gun? Type it here'; inp.value = ''; }
    }
  }
  function applyFit() {
    clearFit(); renderGun();
    if (!S.gun) return;
    var r = S.gun, nm = gunShort(r);
    loadHandles().then(function (H) {
      var fits = [], neutral = [], no = [];
      cards.forEach(function (c) {
        if (has(c, 'used')) return;
        var h = fitHandle(c.dataset.fam, r), f = c.querySelector('.ucc-card__fit');
        if (h === undefined) { neutral.push(c); return; }
        // Used 204 sells as a 223 (Dave, 20 Oct 2026)
        if (USED && h && H[h] !== true && /-223$/.test(h) && H[h.replace(/223$/, '204')] === true) h = h.replace(/223$/, '204');
        if (USED && h && H[h] !== true) { c.classList.add('is-nofit'); f.textContent = 'None used in your size right now'; f.hidden = false; no.push(c); return; }
        if (h && (h in H)) {
          var size = h.replace(/^.*-(\d{3})$/, '$1'), g3 = /urban-carry-g3-([a-z]+)-/.exec(h);
          c.classList.add('is-fit');
          // A card with a page of its own keeps it; that page reads the saved gun (shoulder builder)
          c.querySelector('a').href = c.dataset.fixed ? c.dataset.href : '/products/' + h + (r[14] ? '#for/' + encodeURIComponent(r[0]) : '');
          f.innerHTML = '<b>Fits your gun</b>' + (g3 ? ' · ' + esc(g3[1].charAt(0).toUpperCase() + g3[1].slice(1)) : (/^\d{3}$/.test(size) ? ' · size ' + size : '')) + (H[h] === false ? ' · sold out' : '');
          f.hidden = false; fits.push(c);
        } else {
          c.classList.add('is-nofit');
          f.textContent = c.dataset.fam === 'g3-click' && r[15] === 'R' && handleFor('g3-magnet', r) ? 'Revolvers take the Magnet version' : 'Not made for your ' + nm; f.hidden = false; no.push(c);
        }
      });
      // Fits first, then the pouches and accessories, then the ones that do not fit (kept, greyed: some carry more than one gun)
      var cc = neutral.filter(function (c) { return has(c, 'cancan'); }); neutral = neutral.filter(function (c) { return !has(c, 'cancan'); });
      fits.concat(neutral, cc, no).forEach(function (c) { grid.appendChild(c); });
      cards.filter(function (c) { return has(c, 'used'); }).forEach(function (c) { grid.appendChild(c); });
      track('catalog_fit_shown', { gun: r[0], fits: fits.length, not: no.length });
    }).catch(function (e) { console.log('uc-catalog fit', e); clearFit(); renderGun(); });
  }
  function setGun(id) {
    if (!id) { S.gun = null; applyFit(); return; }
    loadGuns().then(function (G) {
      S.gun = null; for (var i = 0; i < G.length; i++) if (G[i][0] === id) { S.gun = G[i]; break; }
      applyFit();
    }).catch(function (e) { console.log('uc-catalog guns', e); S.gun = null; renderGun(); });
  }
  // The GunMatch bar calls this instead of leaving the page
  window.UCCAT = { setGun: function (id) { setGun(id); var g = $('ucc-gun'); if (g && g.getBoundingClientRect().top < 0) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); } };

  root.addEventListener('click', function (e) {
    var t = e.target, ch = t.closest('[data-chip]');
    if (ch) { chipClick(ch.getAttribute('data-chip')); return; }
    var g = t.closest('[data-gun]'); if (!g) return;
    if (g.getAttribute('data-gun') === 'clear') { try { localStorage.removeItem('gunmatch'); } catch (x) {} S.gun = null; applyFit(); var i = document.getElementById('ucc-q'); if (i) i.focus(); }
  });

  renderChips(); applyChip();
  moreStyles().then(function () { findPresent(); renderChips(); applyChip(); if (S.gun) applyFit(); });
  var saved = null; try { saved = JSON.parse(localStorage.getItem('gunmatch') || 'null'); } catch (e) {}
  if ($('ucc-gun') && saved && saved.id) setGun(saved.id); else renderGun();
})();
